/**
 * Component to display a radio button for user to select the notification method
 * Shows a tooltip if the driver does not have a valid contact method
 * @param type - The type of notification method to display
 * @param selectedDriver - The selected driver
 * @param selectedDriverOption - The selected driver option
 */
import React from 'react';
import { Box } from '@mui/material';
import { FC } from 'react';
import TwRadioButton from '../TwRadioButtons/TwRadioButtons';
import TwTooltip from '../TwTooltip/TwTooltip';

interface NotificationMethodButtonProps {
  type: 'phone' | 'email';
  hasContactInfo: boolean;
}

const NotificationMethodButton: FC<NotificationMethodButtonProps> = ({ type, hasContactInfo }) => {
  const isPhone = type === 'phone';
  const label = isPhone ? 'Send as text message' : 'Send via email';
  const tooltipMessage = isPhone
    ? 'Selected driver must have a valid phone number to share via text'
    : 'Selected driver must have a valid email to share via email';

  if (!hasContactInfo) {
    return (
      <TwTooltip title={tooltipMessage} placement="top-end">
        <Box>
          <TwRadioButton
            value={type}
            onInputChange={(): null => null}
            name="radio"
            label={label}
            disabled={true}
            classNames="notify-driver__send-label"
          />
          <span aria-label={`tooltip-${type}`}></span>
        </Box>
      </TwTooltip>
    );
  }

  return (
    <TwRadioButton
      name="radio"
      label={label}
      value={type}
      onInputChange={(): null => null}
      classNames="notify-driver__send-label"
      disabled={!hasContactInfo}
    />
  );
};

export default NotificationMethodButton;
